import React, { useState, SyntheticEvent } from "react";
import i18n from "../../i18n/config";
import { ICONS } from "../../constants/enums";

import Alert from "../Common/Alerts/Alert";

const ActivateCardInstructions = ({ isInAppCard }: { isInAppCard: boolean }) => {
  const [detailsState, setDetailsState] = useState({ open: false });

  const handleOpen = (e: SyntheticEvent<HTMLElement, Event>) => {
    const target = e.target as HTMLDetailsElement;
    const newState = { open: false };

    if (target.open) {
      newState.open = true;
    } else {
      newState.open = false;
    }

    setDetailsState({ ...newState });
  }

  return (
    <>
      {!isInAppCard &&
        <>
          <p className="navy-blue bold large">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.INSTRUCTIONS.HEADING")}</p>
          <p className="marengo-grey">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.INSTRUCTIONS.PHYSICAL_CARD_INFO")}</p>
        </>
      }

      <p className="marengo-grey">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.INSTRUCTIONS.LIST_HEADING")}</p>
      <ul className="marengo-grey">
        <li>{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.INSTRUCTIONS.LI_1")}</li>
        <li>{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.INSTRUCTIONS.LI_2")}</li>
      </ul>

      <details onToggle={(e) => handleOpen(e)} className="spacing-top-small bg-color-white border-all border--beluga-white padding-default-small border-radius spacing-bottom-small">
        <summary>
          <div className="flex-row justify-content-between align-items-start">
            <p className="bold abyss-blue spacing-bottom-none">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.DETAILS.SUMMARY")}</p>
            <span className="spacing-left-small font-size-xl abyss-blue">{detailsState.open ? '-' : '+'} </span>
          </div>
        </summary>

        <p className="marengo-grey spacing-bottom-none padding-top-small">
          {i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.DETAILS.DESCRIPTION")}
        </p>
      </details>

      <Alert
        alertClasses={`alert-info flex-row align-items-start w-full bg-color-white`}
        isHTML={true}
        icon={ICONS.INFO}
        iconClasses={"spacing-right-tiny"}
      >
        <p className="bold large">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.NOTICE.HEADING")}</p>
        <ul className="padding-left-small">
          <li><span className="bold">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.NOTICE.BOLD_TEXT")}</span> {i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.NOTICE.LI_1")}</li>
          <li><span className="bold">{i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.NOTICE.BOLD_TEXT")}</span> {i18n.t("PAGES.MY_CARD.ACTIVATE_CARD.NOTICE.LI_2")}</li>
        </ul>

      </Alert>
    </>
  );
}

export default ActivateCardInstructions;